import React from 'react';
import { PrimaryButton } from '../button';
import styled, { css } from 'styled-components';
import { breakpoint, theme } from '../../theme';
import Link from 'next/link';
import { BodyText, Heading } from '../typography';

export type TopBannerProps = {
  label: string;
  image: {
    url: string;
  };
  title?: string;
  body?: string;
  ctaUrl?: string;
  ctaText?: string;
};

const Container = styled.section<{ $imageUrl: string }>`
  width: 100%;
  max-width: 100%;

  .bg-image {
    height: 450px;
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    padding: ${theme.spacings[4].rem};

    ${({ $imageUrl }) => css`
      background-image: url(${$imageUrl});
    `}

    ${breakpoint('sm')`
      height: 400px;
      padding: ${theme.spacings[4].rem} ${theme.spacings[7].rem};
    `}
  }

  .content {
    padding: ${theme.spacings[7].rem};
    background: rgba(255, 255, 255, 0.9);
    border-radius: ${theme.borderRadius.default};
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: ${theme.spacings[3].rem};

    ${breakpoint('sm')`
      ${theme.spacings[3].rem};
    `}

    ${breakpoint('lg')`
      min-width: 343px;
      max-width: 900px;
    `}
  }
`;

export const TopBanner = ({
  image,
  title,
  body,
  ctaUrl,
  ctaText,
}: TopBannerProps): JSX.Element => {
  return (
    <Container $imageUrl={image?.url}>
      <div className="bg-image">
        {(title || body) && (
          <div className="content">
            {title && <Heading size={3}>{title}</Heading>}
            {body && <BodyText size="md">{body}</BodyText>}
            {ctaText && (
              <Link href={ctaUrl || '#'}>
                <PrimaryButton>{ctaText}</PrimaryButton>
              </Link>
            )}
          </div>
        )}
      </div>
    </Container>
  );
};
